/** Max parallel requests per list action (move to trash, restore, update, etc.). */
export const LIST_ACTION_CONCURRENCY = 5;
